// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DeliveryModeBadge_badge__j9HNj {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  line-height: 1.4;
  border: 1px solid transparent;
  white-space: nowrap;
}

.DeliveryModeBadge_xs__oAJ3w {
  font-size: 10px;
  padding: 1px 6px;
}

.DeliveryModeBadge_online__Fw4w5 {
  background: rgba(87, 188, 143, 0.15);
  color: #2d8758;
  border-color: rgba(87, 188, 143, 0.4);
}

.DeliveryModeBadge_mixed__43BBX {
  background: rgba(184, 185, 66, 0.15);
  color: #7e8000;
  border-color: rgba(184, 185, 66, 0.4);
}

.DeliveryModeBadge_offline__cm2R6 {
  background: rgba(122, 122, 122, 0.12);
  color: #555;
  border-color: rgba(122, 122, 122, 0.35);
}

.DeliveryModeBadge_unknown__PrRBB {
  background: #f4f5f7;
  color: #acacac;
  border-color: #dbdbdb;
}`, "",{"version":3,"sources":["webpack://./src/dashboard/components/SyncMonitor/DeliveryModeBadge/DeliveryModeBadge.module.scss","webpack://./src/_common/scss/_colors.scss"],"names":[],"mappings":"AAGA;EACE,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;EACA,6BAAA;EACA,mBAAA;AAFF;;AAKA;EACE,eAAA;EACA,gBAAA;AAFF;;AAKA;EACE,oCAAA;EACA,cAAA;EACA,qCAAA;AAFF;;AAKA;EACE,oCAAA;EACA,cAAA;EACA,qCAAA;AAFF;;AAKA;EACE,qCAAA;EACA,WAAA;EACA,uCAAA;AAFF;;AAKA;EACE,mBClCS;EDmCT,cCjCS;EDkCT,qBCnCS;ADiCX","sourcesContent":["@import '@common/scss/_variables';\n@import '@common/scss/_colors';\n\n.badge {\n  display: inline-block;\n  padding: 2px 8px;\n  border-radius: 10px;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  line-height: 1.4;\n  border: 1px solid transparent;\n  white-space: nowrap;\n}\n\n.xs {\n  font-size: 10px;\n  padding: 1px 6px;\n}\n\n.online {\n  background: rgba(87, 188, 143, 0.15);\n  color: #2d8758;\n  border-color: rgba(87, 188, 143, 0.4);\n}\n\n.mixed {\n  background: rgba(184, 185, 66, 0.15);\n  color: #7e8000;\n  border-color: rgba(184, 185, 66, 0.4);\n}\n\n.offline {\n  background: rgba(122, 122, 122, 0.12);\n  color: #555;\n  border-color: rgba(122, 122, 122, 0.35);\n}\n\n.unknown {\n  background: $grey-100;\n  color: $grey-300;\n  border-color: $grey-200;\n}\n","$primary: var(--primary-color);\n$secondary: var(--secondary-color);\n$accent: var(--accent-color);\n$font-primary: var(--font-primary-color);\n$font-secondary: var(--font-secondary-color);\n$font-accent: var(--font-accent-color);\n$grey-100: #f4f5f7;\n$grey-200: #dbdbdb;\n$grey-300: #acacac;\n$grey-400: #838383;\n$chart-dataset-1: #df6767;\n$chart-dataset-2: #efa12c;\n$warning: orange;\n$error: #df6767;\n$white: #fff;\n$transparent: transparent;\n\n$primary-font-color: #fff;\n$secondary-font-color: #fff;\n$accent-font-color: #fff;\n$warning-font-color: #fff;\n$error-font-color: #fff;\n$filter-bg: #fff;\n\n$bg-main: var(--background-color);\n$card-bg: #fff;\n$default-control-bg: #fff;\n$card-shadow: 3px 3px 3px -1px rgba(0, 0, 0, 0.1);\n$default-shadow-color: rgba(0, 0, 0, 0.1);\n\n$default-border-color: #acacac;\n$default-backdrop-color: rgba(0, 0, 0, 0.8);\n\n$default-navbar-color: #fff;\n\n$stats-card-bg-color: #fff;\n$stats-card-color: #000;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"badge": `DeliveryModeBadge_badge__j9HNj`,
	"xs": `DeliveryModeBadge_xs__oAJ3w`,
	"online": `DeliveryModeBadge_online__Fw4w5`,
	"mixed": `DeliveryModeBadge_mixed__43BBX`,
	"offline": `DeliveryModeBadge_offline__cm2R6`,
	"unknown": `DeliveryModeBadge_unknown__PrRBB`
};
export default ___CSS_LOADER_EXPORT___;
